import { AlertTriangle, Trash2, X } from "lucide-react";
import { useEffect, useId } from "react";

interface AdminConfirmDialogProps {
  title: string;
  description: string;
  subject: string;
  confirmLabel: string;
  busyLabel?: string;
  eyebrow?: string;
  note?: string;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
}

export function AdminConfirmDialog({ title, description, subject, confirmLabel, busyLabel = "Wird gelöscht…", eyebrow = "Endgültige Aktion", note = "Diese Aktion kann nicht rückgängig gemacht werden.", busy = false, onCancel, onConfirm }: AdminConfirmDialogProps) {
  const titleId = useId();
  const descriptionId = useId();

  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && !busy) onCancel();
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [busy, onCancel]);

  return (
    <div className="editor-overlay admin-confirm-overlay" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget && !busy) onCancel(); }}>
      <section className="admin-confirm-dialog" role="alertdialog" aria-modal="true" aria-labelledby={titleId} aria-describedby={descriptionId}>
        <button type="button" className="admin-confirm-close" onClick={onCancel} disabled={busy} aria-label="Dialog schließen"><X /></button>
        <span className="admin-confirm-icon"><AlertTriangle /></span>
        <span className="admin-confirm-eyebrow">{eyebrow}</span>
        <h2 id={titleId}>{title}</h2>
        <p id={descriptionId}>{description}</p>
        <strong className="admin-confirm-subject">{subject}</strong>
        <div className="admin-confirm-note"><AlertTriangle /><span>{note}</span></div>
        <div className="admin-confirm-actions">
          <button type="button" className="admin-secondary-button" onClick={onCancel} disabled={busy}>Abbrechen</button>
          <button type="button" className="admin-danger-button" onClick={() => void onConfirm()} disabled={busy}><Trash2 /> {busy ? busyLabel : confirmLabel}</button>
        </div>
      </section>
    </div>
  );
}
